import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';

// Material UI
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import TablePagination from '@mui/material/TablePagination';
import IconButton from '@mui/material/IconButton';

// Icons
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

// Components
import TextField from '../../../../components/inputs/input';
import Table from '../../../../components/table';
import EditDetailModal from '../editDetailModal';
import useStyles from './styles';
import { columnsAdjustment, types } from '../../../../models/MovementEntity';
import { stockControllUtils } from '../../../../utils/stockControll-utils';
import AutoComplete from '../../../../components/inputs/Autocomplete'
import { createFilterOptions } from '@mui/material/Autocomplete';

const MovementDetailsTable = ({ details, onAdd, onRemove, onChange, onAddMassive, adjustmentTypesOptions, movementType, adjustmentTypesChange }) => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [refId, setRefId] = useState('');
    const [openDetail, setOpenDetail] = useState(false);
    const [detailSelected, setDetailSelected] = useState(null);
    const [adjustmentTypes, setAdjustmentTypes] = useState({});
    const { classes } = useStyles();

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const handleAddProduct = () => {
        onAdd(refId, adjustmentTypes);
        setRefId('');
    }

    const handleRemoveProduct = (refId) => {
        onRemove(refId);
        setRefId('');
    }

    const onLoadFile = async (e) => {
        e.preventDefault();

        const file = e.target.files;
        const reader = new FileReader();

        reader.onloadend = async (e) => {
            const content = (e.target.result);
            const productsArray = stockControllUtils.parseContent(content);
            onAddMassive(productsArray);
        };

        reader.readAsText(file[0]);
        e.target.value = null;
    };

    const handleInputChange = (event) => {
        setRefId(stockControllUtils.formatRefId(event.target.value))
    }

    const handleKeyPress = (e) => {
        if (e.key === 'Enter')
            handleAddProduct()
    }

    const handleAdjustmentTypes = (event, value) => {
        setAdjustmentTypes(value);
        adjustmentTypesChange(value);
    }

    return (
        <>
            <Grid size="grow">
                <Paper className={classes.paper}>
                    <Typography variant="h4">
                        {movementType === types.Ingress ? 'Ingreso' : 'Egreso'}
                    </Typography>
                </Paper>
            </Grid>
            <Paper>
                {
                    openDetail &&
                    <EditDetailModal
                        detail={detailSelected}
                        open={openDetail}
                        onClose={() => setOpenDetail(false)}
                        onSave={onChange}
                        adjustmentTypesOptions={adjustmentTypesOptions}
                    />
                }
                <Grid container direction='column'>
                    <Grid container spacing={1} alignItems='center' style={{ padding: '8px 16px' }}>
                        <Grid container direction='column' size={3}>
                            <Typography
                                component='h2'
                                color='primary'
                                variant='h5'
                            >
                                Detalles
                            </Typography>
                        </Grid>
                        <Grid size={3}>
                            <TextField
                                fullWidth
                                name='refId'
                                label='SKU o Módulo'
                                onChange={handleInputChange}
                                onKey
                                value={refId}
                                size='small'
                                onKeyPress={handleKeyPress}
                            />
                        </Grid>
                        <Grid size={1}>
                            <Button
                                fullWidth
                                color='primary'
                                variant='contained'
                                onClick={handleAddProduct}
                                disabled={!refId}
                            >
                                Agregar
                            </Button>
                        </Grid>
                        <Grid size={2}>
                            <div className="upload-btn-wrapper">
                                <Button
                                    fullWidth
                                    variant="contained"
                                    component="label"
                                    color='primary'
                                >
                                    Cargar Archivo
                                    <input
                                        type="file"
                                        hidden
                                        onChange={onLoadFile}
                                    />
                                </Button>
                            </div>
                        </Grid>
                        <Grid size={3}>
                            <AutoComplete
                                fullWidth
                                onChange={handleAdjustmentTypes}
                                options={adjustmentTypesOptions}
                                getOptionLabel={(option) => option?.description}
                                size='small'
                                TextProps={{
                                    label: 'Tipo de ajuste',
                                    required: true,
                                }}
                                filterOptions={createFilterOptions({
                                    stringify: (option) => option.description + option.code,
                                })}
                                renderOption={(props, option) => (
                                    <li {...props}>
                                        <span color='secondary'>{`${option.code} - ${option.description}`}</span>
                                    </li>
                                )}
                            />
                        </Grid>
                    </Grid>
                    <Grid>
                        <Divider />
                        <Table
                            rows={details}
                            columns={columnsAdjustment}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            actions={(item) =>
                                <>
                                    <IconButton
                                        size='small'
                                        color='primary'
                                        onClick={() => {
                                            setOpenDetail(true);
                                            setDetailSelected(item);
                                        }}
                                    >
                                        <EditIcon />
                                    </IconButton>
                                    <IconButton
                                        size='small'
                                        color='primary'
                                        onClick={() => handleRemoveProduct(item.refId)}
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                </>}
                        />
                        <TablePagination
                            count={details.length}
                            rowsPerPageOptions={[10, 25, 100]}
                            component="div"
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={(e, newPage) => setPage(newPage)}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Grid>
                </Grid>
            </Paper>
        </>
    );
}

MovementDetailsTable.defaultProps = {
    details: [],
    onAdd: () => { },
    onRemove: () => { },
    onChange: () => { }
}

MovementDetailsTable.prototype = {
    details: PropTypes.arrayOf(PropTypes.object),
    onAdd: PropTypes.func,
    onRemove: PropTypes.func,
    onChange: PropTypes.func
}

export default MovementDetailsTable;